// extracted by mini-css-extract-plugin
export default {"main-block":"kOVrV","item":"ZH7ZO"};